import React from 'react';

const Vue_Transition = () => {
  return (
    <div>
      <h1>Vue_Transition Component</h1>
      <p>This is the Vue_Transition tutorial page.</p>
    </div>
  );
}

export default Vue_Transition;
